import { defineStore } from "pinia"
import { ref } from 'vue'
import { AxiosError } from "axios"
import type { Ref } from 'vue'

interface ErrorMessageObj {
    error: AxiosError | Record<string, unknown>
    message: string
}

export const useErrorStore = defineStore('Error_Network', () => {
    const errors: Ref<Array<ErrorMessageObj>> = ref([])
    const pushError = (errorObj: ErrorMessageObj) => {
        errors.value.push(errorObj)
    }

    return {
        errors,
        pushError
    }
})